
import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../constant/path";
import ReCAPTCHA from "react-google-recaptcha";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    requirements: "customised",
    event_type: "Other",
    location: "",
    customLocation: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "requirements"),
    }));
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      location: value,
      customLocation: "",
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required.";
    if (!formData.lastName.trim())
      newErrors.lastName = "Last name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required.";
    if (!formData.location.trim())
      newErrors.location = "Please specify a location.";
    if (formData.location === "Other" && !formData.customLocation.trim())
      newErrors.customLocation = "Please enter a custom location.";
    if (!captchaValue) newErrors.captcha = "Please complete the CAPTCHA.";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setErrorMessage("");
    setSubmitted(false);

    try {
      const formattedFormData = {
        ...formData,
        full_name: `${formData.firstName} ${formData.lastName}`.trim(),
        captcha: captchaValue,
        location:
          formData.location === "Other"
            ? formData.customLocation
            : formData.location,
      };

      delete formattedFormData.firstName;
      delete formattedFormData.lastName;
      delete formattedFormData.customLocation;

      const response = await axios.post(
        `${API_BASE_URL}api/contact/`,
        formattedFormData
      );

      if (response?.data?.success) {
        setSubmitted(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          requirements: "customised",
          event_type: "customised",
          location: "",
          customLocation: "",
        });
        setErrors({});
        setCaptchaValue(null);
        setErrorMessage("");
      } else {
        setErrorMessage(
          response.data.error || "Failed to send message. Please try again."
        );
      }
    } catch (error) {
      const backendErrors = error.response?.data;
      if (backendErrors?.error) {
        setErrorMessage(backendErrors.error);
      } else {
        setErrorMessage("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    setErrors((prev) => ({ ...prev, captcha: "" }));
  };

  return (
    <div
      id="contact"
      className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4 md:p-8 relative"
      style={{
        backgroundImage: `url('/WhatsApp Image 2025-08-21 at 4.43.43 PM.jpeg')`,
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      <div className="relative z-10 w-full max-w-full md:max-w-6xl bg-white rounded-lg shadow-lg grid grid-cols-1 md:grid-cols-2 overflow-hidden">
        {/* Contact Info */}
        <div className="p-6 md:p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-6 relative inline-block">
            Contact <span className="relative z-10">Us</span>
            <span className="absolute bottom-0 left-0 w-16 h-1 bg-blue-600 z-0"></span>
          </h1>
          <div className="space-y-4 text-gray-700">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-blue-100 rounded-md flex items-center justify-center mr-4">
                📧
              </div>
              <div>
                <h3 className="font-semibold">Email</h3>
                <p>help@expressearth.com</p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="w-12 h-12 bg-blue-100 rounded-md flex items-center justify-center mr-4">
                📞
              </div>
              <div>
                <h3 className="font-semibold">Phone</h3>
                <a href="tel:+919266056660" >+91 92660 56660</a>

              </div>
            </div>
            <div className="flex items-start">
              <div className="w-12 h-12 bg-blue-100 rounded-md flex items-center justify-center mr-4">
                🌐
              </div>
              <div>
                <h3 className="font-semibold">Website</h3>
                <a href="https://www.expressearth.com" target="_blank">expressearth.com</a>
              </div>
            </div>
            <div className="flex items-start">
              <div className="w-12 h-12 bg-blue-100 rounded-md flex items-center justify-center mr-4">
                📍
              </div>
              <div>
                <h3 className="font-semibold">Location</h3>
                <p>Vipul Trade Centre, Gurgaon</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="p-6 md:p-8 bg-gradient-to-br from-blue-100 to-blue-300">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center md:text-left">
              Get in touch.
            </h2>
            <div className="mt-4 sm:mt-0 text-center md:text-right">
              <span className="text-blue-600 font-bold">Express</span>{" "}
              <span className="text-green-600 font-bold">Earth</span>
              {/* <div className="w-8 h-1 bg-blue-600 mt-1 ml-auto"></div> */}
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            {/* First Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full p-3 border-b-2 border-gray-300 focus:border-blue-600 bg-transparent outline-none"
                />
                {errors.firstName && (
                  <p className="text-red-600 text-sm">{errors.firstName}</p>
                )}
              </div>
              <div>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full p-3 border-b-2 border-gray-300 focus:border-blue-600 bg-transparent outline-none"
                />
                {errors.lastName && (
                  <p className="text-red-600 text-sm">{errors.lastName}</p>
                )}
              </div>
            </div>

            {/* Second Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 border-b-2 border-gray-300 focus:border-blue-600 bg-transparent outline-none"
                />
                {errors.email && (
                  <p className="text-red-600 text-sm">{errors.email}</p>
                )}
              </div>
              <div>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone No."
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full p-3 border-b-2 border-gray-300 focus:border-blue-600 bg-transparent outline-none"
                />
                {errors.phone && (
                  <p className="text-red-600 text-sm">{errors.phone}</p>
                )}
              </div>
            </div>

            {/* Radio Buttons */}
            <div className="mb-4">
              <p className="text-sm font-medium text-gray-700 mb-2">
                Interested in
              </p>
              <div className="flex flex-wrap gap-4">
                <label className="flex items-center text-gray-600 text-sm cursor-pointer">
                  <input
                    type="radio"
                    name="requirements"
                    value="customised"
                    checked={formData.requirements === "customised"}
                    onChange={handleChange}
                    className="mr-2"
                  />
                  Customised Personal Tour
                </label>
                <label className="flex items-center text-gray-600 text-sm cursor-pointer">
                  <input
                    type="radio"
                    name="requirements"
                    value="group"
                    checked={formData.requirements === "group"}
                    onChange={handleChange}
                    className="mr-2"
                  />
                  Personalised Group Tour
                </label>
              </div>
            </div>

            {/* Location Select */}
            <div className="mb-6">
              <p className="text-sm font-medium text-gray-700 mb-2">
                Select Location
              </p>
              <select
                name="location"
                value={formData.location}
                onChange={handleLocationChange}
                className="w-full p-3 border-2 border-gray-300 rounded-md focus:border-blue-600"
              >
                <option value="">Select a location</option>
                <option value="Bali">Bali</option>
                <option value="Georgia">Georgia</option>
                <option value="India">India</option>
                <option value="Goa">Goa</option>
                <option value="Other">Other</option>
              </select>

              {formData.location === "Other" && (
                <input
                  type="text"
                  name="customLocation"
                  placeholder="Enter custom location"
                  value={formData.customLocation}
                  onChange={handleChange}
                  className="mt-3 w-full p-3 border-2 border-gray-300 rounded-md focus:border-blue-600"
                />
              )}

              {errors.location && (
                <p className="text-red-600 text-sm mt-1">{errors.location}</p>
              )}
              {errors.customLocation && (
                <p className="text-red-600 text-sm mt-1">
                  {errors.customLocation}
                </p>
              )}
            </div>

            {/* CAPTCHA */}
            <div className="mb-6">
              <ReCAPTCHA
                sitekey="6LfG7hsrAAAAABrKlWfFUvwsE5GhzxM7YD6IfhYP"
                onChange={handleCaptchaChange}
              />
              {errors.captcha && (
                <p className="text-red-600 text-sm mt-2">{errors.captcha}</p>
              )}
            </div>

            {/* Submit button */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 rounded-md font-semibold transition ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-700"
              }`}
            >
              {loading ? "Submitting..." : "SUBMIT"}
            </button>

            {/* Messages */}
            {errorMessage && (
              <p className="text-red-600 text-sm mt-3">{errorMessage}</p>
            )}
            {submitted && !errorMessage && (
              <p className="text-green-600 text-sm mt-3">
                Form submitted successfully!
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
